module.exports = __webpack_public_path__ + "img/G_Art_Claw_R_3_2_3.ab4f0be1.png";